export const sidebarColours = {
    bg: 'rgb(35, 48, 68)',      // ← requested background
    text: '#cbd5e1',
    textSubtle: '#94a3b8',
    textStrong: '#e5e7eb',
    divider: 'rgba(148,163,184,.25)',
    hover: 'rgba(255,255,255,.06)',
    activeBg: 'rgba(255,255,255,.08)',
    chipBg: 'rgba(148,163,184,.12)',
    focusBar: '#6366f1',
};
